"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = jsNumberForAddress;
function jsNumberForAddress(address) {
  var addr = address.replace(/[^0-9abcdef]+/g, '0').slice(0, 8).padEnd(8, "abcdef0123456789");
  var seed = parseInt(addr, 16);
  return seed;
}